import React from 'react';
import  { connect } from 'react-redux';

import { filterByDepartureTiming } from '../../../store/actions/flights';

import lateNightImage from '../../../assets/images/late-night.svg';
import morningImage from '../../../assets/images/morning.svg';
import eveningImage from '../../../assets/images/evening.svg';
import nightImage from '../../../assets/images/night.svg';

import FilterButtonLarge from '../FilterButtonLarge/FilterButtonLarge';

const filterDeparture = (props) => (
    <div className={`u-flex`}>
        <FilterButtonLarge image={lateNightImage} isActive={props.departuresActive.includes(0)} clicked={() => props.onFilterByDepartureTiming(0)}>0-6hrs</FilterButtonLarge>
        <FilterButtonLarge image={morningImage} isActive={props.departuresActive.includes(1)} clicked={() => props.onFilterByDepartureTiming(1)}>6-12hrs</FilterButtonLarge>
        <FilterButtonLarge image={eveningImage} isActive={props.departuresActive.includes(2)} clicked={() => props.onFilterByDepartureTiming(2)}>12-18hrs</FilterButtonLarge>
        <FilterButtonLarge image={nightImage} isActive={props.departuresActive.includes(3)} clicked={() => props.onFilterByDepartureTiming(3)}>18-0hrs</FilterButtonLarge>
    </div>
)

const mapStateToProps = state => {
    return {
        departuresActive: state.flights.selectedDepartures
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFilterByDepartureTiming: (timeIndex) => dispatch(filterByDepartureTiming(timeIndex))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(filterDeparture);


// WEBPACK FOOTER //
// ./src/components/Filters/FilterDeparture/FilterDeparture.js